import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg
      width="6"
      height="3"
      viewBox="0 0 6 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 3L0.401924 4.89399e-07L5.59808 3.51373e-08L3 3Z"
        fill="#8E8E8E"
      />
    </svg>
  );
};

export default Svg;

